module.exports = __webpack_public_path__ + "static/media/S_S02.8ba53af2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/S_S02.png
// module id = 84
// module chunks = 0